import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { config } from '../../../../assets/config-constant';

@Component({
  selector: 'app-notices-dialog',
  templateUrl: './notices-dialog.component.html',
  styleUrls: ['./notices-dialog.component.scss'],
  standalone: false,
})
export class NoticesDialogComponent implements OnInit {
  fileContent: string;

  constructor(
    private http: HttpClient,
    private readonly dialogRef: MatDialogRef<NoticesDialogComponent>,
    private readonly ngZone: NgZone,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.http
      .get(config.thirdPartyNoticesLocation, { responseType: 'text' })
      .subscribe({
        next: (data) => {
          this.ngZone.run(() => {
            this.fileContent = data
              .replace(/\\r\\n\\r\\n\\r\\n\\r\\n\\r\\n\\r\\n/, '')
              .replace(/\\n/g, '\n')
              .replace(/\\'/g, "'")
              .replace(/\\"/g, '"')
              .replace(/\\&/g, '&')
              .replace(/\\r/g, '\r')
              .replace(/\\t/g, '\t')
              .replace(/\\b/g, '\b')
              .replace(/\\f/g, '\f');
            this.cdr.detectChanges();
          });
        },
        error: () => {
          this.ngZone.run(() => {
            this.fileContent = 'Third party notices are currently unavailable.';
            this.cdr.detectChanges();
          });
        },
      });
  }

  ngOnInit(): void { /* do nothing */ }
  onCancelClick(): void {
    this.dialogRef.close();
  }
}
